import { render, staticRenderFns } from "./ModalSender.vue?vue&type=template&id=f0d3f05e"
import script from "./ModalSender.vue?vue&type=script&lang=js"
export * from "./ModalSender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports